import * as React from 'react';
import styled from 'styled-components';
import { StackPanel } from '../../stack-panel';
import { selectThemeSemantics } from '../../../styling';
import { IFlyoutProps } from '../flyout-props';

const FooterWrapper = styled(StackPanel).attrs(() => ({
    className: String('ap-flyout-footerWrapper')
})) <{ $footerAlignment?: 'left' | 'center' | 'right' }>`
    box-sizing: border-box;
    text-align: right;
    width: 100%;
    height: auto;
    padding: ${selectThemeSemantics(({ gap }) => `${gap.none} ${gap.xxxxl}`)};
    justify-content: ${({ $footerAlignment }) => ($footerAlignment === 'center' ? 'center' : 'flex-end')};
`;

export interface IFlyoutFooterProps extends Pick<IFlyoutProps, 'footerAlignment' | 'onRenderFooterContent'> { }

export function FlyoutFooter(props: IFlyoutFooterProps) {
    const { onRenderFooterContent, footerAlignment } = props;
    return onRenderFooterContent === undefined ? null : (
        <FooterWrapper
            gap='16'
            orientation="horizontal"
            flip={footerAlignment === 'left'}
            $footerAlignment={footerAlignment}>
            {onRenderFooterContent() as React.ReactElement}
        </FooterWrapper>
    );
}
